/* eslint-disable no-console */
/**
 * The app provider module
 *
 * for some reasons ive used ref
 */

const TagCustomizer = () => import('@gocream/tag-customizer');

let app = null;

const provider = Object.freeze({
	get app() {
		return app;
	},

	async init(...args) {
		if (app !== null) {
			console.warn('appProvider.init(): the app is already initialized. Destroy it before with appProvider.destroy()');
			app.destroy();
		}

		const { ThreeApp } = await TagCustomizer();
		const instance = new ThreeApp(...args);
		const { destroy } = instance;

		// patching destroy method;
		instance.destroy = (...$args) => {
			destroy.call(instance, $args);
			app = null;
		};
		app = instance;

		// fake
		return app;
	},

	destroy() {
		if (app === null) {
			console.warn('appProvider.destroy(): the app is already destroyed or not initialized yet.');
			return;
		}

		app.destroy();
	},
});

export default provider;
